import useTranslations from 'hooks/useTranslations';
import React from 'react';

import './PageTitle.scss';

const PageTitle = ({
  title = '',
  style = {},
  className = '',
  inputProps = null,
  parameters = [],
  subTitle = null,
}) => {
  const { rcTranslate } = useTranslations();

  return (
    <div className={`pageTitleContainer ${className}`} style={style}>
      <h1 className="pageTitle">{rcTranslate(title, parameters)}</h1>
      {subTitle && <h2 className="subTitle">{subTitle}</h2>}
      {inputProps ? <div className="inputPropsClass">{inputProps}</div> : null}
    </div>
  );
};

export default PageTitle;
